<template>
  <template-personal
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
    :pathName="pathName"
    :showBusiness="showBusiness"
  >
  </template-personal>
</template>

<script>
export default {
  name: "PersonalNormalNotRegister",
  props: ["hasFinalTaxType"],
  data() {
    return {
      showBusiness: false,
      pathName: "personal_normal_not_register",
      fact: [
        "การไม่จด VAT ทำให้คุณไม่มีหลักฐานเพื่อช่วยในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
      ],
    };
  },
  methods: {
    goVatDefinition() {
      this.$router.push({
        path: "/info/vat_definition",
      });
    },
    goVatCalculation() {
      this.$router.push({
        path: "/info/vat_calculation",
      });
    },
    goVatBenefit() {
      this.$router.push({
        path: "/info/vat_benefit",
      });
    },
  },
};
</script>

<style scoped></style>
